import { TranslationKey } from '@types';
import translations from '../constants/translations.json';
import { LangEnum } from '../api/enums';

export const translate = (name: TranslationKey, lang = LangEnum.ENG): string => {
  const value = translations[name];
  return value ? value[lang.toUpperCase()] : 'TEXT';
};
